import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { AssetColumns } from "~/modules/assets/types";
import { Emdash } from "~/components/Punctuation";
import { DataGridDollarPercentChangeComboCell } from "~/components/DataGrid/DataGridDollarPercentChangeComboCell";
import { getMeasureValue } from "~/utils/getMeasureValue";
import { AssetTableRowData } from "../types";
import { CatalogMetricSlugs } from "~/modules/catalog/types";

// // // //

export const CIRCULATING_MARKET_VALUE_DOLLAR_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.circulatingMarketValueDollar,
    label: "Market Cap",
    tooltip: CatalogMetricSlugs.circulating_market_value_dollar,
    type: ColumnTypes.dollar,
    sortsOn: AssetColumns.circulatingMarketValueDollar,
    width: 180,
    render: (item) => {
        const measure = getMeasureValue(
            item,
            "circulating_market_value_dollar",
        );

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridDollarPercentChangeComboCell
                value={measure.val}
                pct_change_interval="30d"
                pct_change_value={measure.chg_30d_pct}
            />
        );
    },
};
